module.exports = __webpack_public_path__ + "img/8.5b1a1eda.png";